/**
 * The address to put in a link's href, or undefined when it is not an
 * http(s) web address. Delivery links are typed in by staff and shown to
 * others as "View" links; a "javascript:" address would run in the viewer's
 * browser. The server refuses new ones - this covers any already stored.
 */
export function webLink(value) {
  try {
    const url = new URL(String(value || "").trim());
    return url.protocol === "http:" || url.protocol === "https:" ? url.href : undefined;
  } catch {
    return undefined;
  }
}
